/**
 * @fileoverview Input/output schemas for split-point-detector-v1.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.charactersCurrent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = z.object({
  lastLineOfFirst: z.string().describe(
    'The exact text of the last sentence that should remain in the first chapter. Copy verbatim from the content — do not paraphrase or truncate.'
  ),
  firstLineOfSecond: z.string().describe(
    'The exact text of the first sentence that should begin the second chapter. Copy verbatim from the content — do not paraphrase or truncate.'
  ),
  explanation: z.string().describe(
    'A brief explanation of why this is a good split point (e.g. scene change, POV shift, tension beat).'
  ),
});

export type Output = z.infer<typeof OutputSchema>;
